/** @format */

import { CalendarMonth } from '@mui/icons-material';
import { Box, Button, Chip, Modal } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { DateRange } from 'react-date-range';
import { useTheme } from '@mui/material/styles';

function DateRangePicker(props) {
  const {
    handleDateRange,
    defaultDateRange,
    minDate,
    maxDate,
    height,
    fullWidth = false,
    isCY = false,
  } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const theme = useTheme();
  if (!defaultDateRange || !defaultDateRange.length) return <></>;

  const { startDate, endDate: baseEndDate, endDateCY } = defaultDateRange[0];
  
  const endDate = isCY && endDateCY ? endDateCY : baseEndDate;

  const handleModal = function () {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-evenly',
          width: fullWidth ? '100%' : 'auto',
        }}
      >
        <Button
          aria-label="Select date range"
          onClick={() => {
            handleModal();
          }}
          size="small"
          variant="outlined"
          sx={{
            display: 'flex',
            borderColor: 'divider',
            gap: '4px',
            flexWrap: 'no-wrap',
            height: height || 'auto',
            width: fullWidth ? '100%' : 'auto',
            justifyContent: 'space-between',
            minWidth: 0,
            textTransform: 'none',
          }}
          endIcon={<CalendarMonth />}
        >
          <Box sx={{ color: theme.palette.text.primary }}>
            <Chip size="small" label={dayjs(startDate).format('D MMM YYYY')} />
          </Box>
          {'-'}
          <Box sx={{ color: theme.palette.text.primary }}>
            <Chip size="small" label={dayjs(endDate).format('D MMM YYYY')} />
          </Box>
        </Button>
      </Box>
      <MyModal
        dateRange={[{ ...defaultDateRange[0], endDate }]}
        handleDateRange={handleDateRange}
        isModalOpen={isModalOpen}
        handleModal={handleModal}
        maxDate={maxDate}
        minDate={minDate}
      />
    </>
  );
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  pt: 2,
  px: 2,
};

const MyModal = function (props) {
  const {
    isModalOpen,
    handleModal,
    dateRange,
    handleDateRange,
    maxDate,
    minDate,
  } = props;

  return (
    <Modal open={isModalOpen} onClose={handleModal}>
      <Box sx={{ ...style }}>
        <DateRange
          editableDateInputs={true}
          onChange={(item) => {
            const selection = { ...item.selection };

            const prev = dateRange?.[0];
            const endChanged =
              prev?.endDate && selection.endDate
                ? !dayjs(prev.endDate).isSame(dayjs(selection.endDate))
                : true;
            if (endChanged || !selection.endDateCY) {
              selection.endDateCY = selection.endDate;
            } else {
              selection.endDateCY = prev.endDateCY;
            }
            handleDateRange([selection]);
          }}
          moveRangeOnFirstSelection={false}
          ranges={dateRange}
          maxDate={maxDate ?? maxDate}
          minDate={minDate ?? minDate}
        />
      </Box>
    </Modal>
  );
};
export default DateRangePicker;
